<template>
  <div class="complete_content">
    <dd-header
      :isMenuView='false'
    />
    <div class="container">
      <div id="content">
        <dd-sitemap
          :pageKey="pageKey"
          :pageList="pageList"
        />
        <section v-if="registType">
          <div class="title">
            <h1>登録完了</h1>
          </div>
          <div>
            <p>
              ご登録ありがとうございました。<br>
              登録完了メールを自動送信しました。
            </p>
          </div>
          <div class="dtl_btn2 btn_pos_center" @click="route('DcSignIn')">ログインページへ</div>
        </section>
        <section v-else>
          <div class="title">
            <h1>申請完了</h1>
          </div>
          <div>
            <p>
              ご登録ありがとうございました。申請完了メールを自動送信しました。<br>
              法人会員アカウントの発行可否は、所定の審査後にメールにてご連絡いたします。
            </p>
          </div>
          <div class="dtl_btn2 btn_pos_center" @click="route('DcTop')">トップページへ</div>
        </section>
      </div>
    </div>
  </div>
</template>
<script>
// Module
import Header from '../components/common/DcHeader'
import * as App from '../../utils/App'
import {DC_STORAGE_KEY} from '../../constants/App'
// import LoginForm from '../components/login/DcLoginForm'
import DDLeftMenu from '../components/top/DcLeftMenu'
import SiteMap from '../components/common/DcSiteMap'

export default {
  name: 'Login',
  components: {
    'dd-header': Header,
    'dd-sitemap': SiteMap,
    // 'dd-login': LoginForm,
    'dd-menu': DDLeftMenu
  },
  data () {
    return {
      pageKey: 'dcRegistComplete',
      pageList: [
        {id: 'dcRegistInput', key: 'dcRegistInput', title: '会員情報入力'},
        {id: 'dcRegistConfirm', key: 'dcRegistConfirm', title: '内容確認'},
        {id: 'dcRegistComplete', key: 'dcRegistComplete', title: '登録完了'}
      ],
      registType: false,
      form: {
        loginId: '',
        password: ''
      },
      /** 共通エラーメッセージ */
      errorMessage: { text: '' },
      /** 項目別エラーメッセージ */
      fieldErrorMessages: {
        loginId: '',
        password: ''
      }
    }
  },
  methods: {
    getImage: function (image) {
      return App.getMmstyleResource(image)
    },
    route: function (name, params) {
      this.$router.push({
        name: name,
        query: params
      })
    }
  },
  created () {
    App.removeLocalStorage(DC_STORAGE_KEY.INVITE_CODE)
    App.removeLocalStorage(DC_STORAGE_KEY.CORP_DATA)
    App.removeLocalStorage(DC_STORAGE_KEY.USER_DATA)
    App.removeLocalStorage(DC_STORAGE_KEY.USER_TYPE)
    this.registType = this.$route.query.type
  }
}
</script>
<style src="../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcRegistUserComplete.vue